import { erpAxios } from '..';

const statusOdbijen = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/odbijen`, data);
  return res;
};

export default statusOdbijen;
